export default __webpack_public_path__ + "static/plexus-full-width-1-314d5c55411c6b7c9d7158818a9bc46a.avif";